var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("rb-product-tile", {
    attrs: { "element-id": _vm.dataElementId, product: _vm.productMap },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }